import { useOwnedStations } from '@app/core/stations/hooks/useOwnedStations';
import { Station } from '@app/core/types/stations';
import { useMemo } from 'react';

/**
 * Resolves station IDs linked to a connection into owned Station objects
 * (linked vs available-to-link), without an extra API call.
 */
export function useConnectionStations(stationIds: string[]) {
  const ownedStations = useOwnedStations();

  const linkedStations = useMemo(() => {
    const byId = new Map(ownedStations.map((s) => [s.id, s]));
    return stationIds
      .map((id) => byId.get(id))
      .filter((s): s is Station => s != null)
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [ownedStations, stationIds]);

  const unlinkedStations = useMemo(() => {
    const linked = new Set(stationIds);
    return ownedStations.filter((s) => !linked.has(s.id));
  }, [ownedStations, stationIds]);

  return {
    stationIds,
    linkedStations,
    unlinkedStations,
  };
}
